<div class="custom-header-container">

  <!-- Add column mode -->
  <ng-container *ngIf="mode === 'add' && canAdd">
    <button
      mat-stroked-button
      class="add-column-btn"
      (click)="openAddColumnDialog()"
      matTooltip="Add custom column">
      <mat-icon>add</mat-icon>
      Add Column
    </button>
  </ng-container>

  <!-- Rename mode -->
  <ng-container *ngIf="mode === 'rename'">
  <div class="custom-col-header-title">
    <span class="col-name">{{ columnName }}</span>

    <button
      *ngIf="canRename"
      mat-icon-button
      [matMenuTriggerFor]="renameMenu"
      #renameTrigger="matMenuTrigger"
      (menuOpened)="onMenuOpen()"
      matTooltip="Rename column"
      class="action-btn rename-btn">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
</ng-container>

</div>

<!-- Rename column menu -->
<mat-menu #renameMenu="matMenu" [hasBackdrop]="true" class="rename-column-menu">
  <div class="rename-panel" (click)="$event.stopPropagation()">
    <div class="rename-panel-header">
      <div>
        <div class="rename-title">Column Settings</div>
        <div class="rename-subtitle">Rename or remove this custom column</div>
      </div>
    </div>

    <mat-form-field appearance="outline" class="rename-field">
      <mat-label>Column Name</mat-label>
      <input
        matInput
        [formControl]="inputControl"
        placeholder="Column name"
        (keydown.enter)="confirmRename()"
        maxlength="50" />
    </mat-form-field>

    <div class="rename-actions">
      <button
        mat-stroked-button
        color="warn"
        *ngIf="canDelete"
        (click)="confirmDelete()">
        <mat-icon>delete_outline</mat-icon>
        Delete
      </button>

      <button
        mat-flat-button
        color="primary"
        (click)="confirmRename()"
        [disabled]="!inputControl.value?.trim()">
        <mat-icon>check</mat-icon>
        Save
      </button>
    </div>
  </div>
</mat-menu>

<!-- Add custom column dialog -->
<ng-template #addColumnDialog>
  <div class="custom-column-dialog">
    <div class="dialog-header">
      <div>
        <h2>Add Custom Column</h2>
        <p>Create a custom field for the grid and form details page.</p>
      </div>

      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-body">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Column Name</mat-label>
        <input
          matInput
          [formControl]="inputControl"
          maxlength="50"
          placeholder="Example: Internal Review Date" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Data Type</mat-label>
        <mat-select [formControl]="dataTypeControl">
          <mat-option value="text">Text</mat-option>
          <mat-option value="number">Number</mat-option>
          <mat-option value="date">Date</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="settings-card">
      

        <div class="setting-row">
          <div>
            <div class="setting-title">Show in Grid</div>
            <div class="setting-desc">Display this custom field as a grid column.</div>
          </div>
          <mat-slide-toggle [formControl]="isVisibleInGridControl"></mat-slide-toggle>
        </div>

        <div class="setting-row">
          <div>
            <div class="setting-title">Show in Form</div>
            <div class="setting-desc">Display this field on the form details page.</div>
          </div>
          <mat-slide-toggle [formControl]="isVisibleInFormControl"></mat-slide-toggle>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <button mat-stroked-button mat-dialog-close>
        Cancel
      </button>

      <button
        mat-flat-button
        color="primary"
        (click)="confirmAdd()"
        [disabled]="!inputControl.value?.trim() || !dataTypeControl.value">
        Save Column
      </button>
    </div>
  </div>
</ng-template>